import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';
import { getBrowserName, isDesktop } from './browser-util';
import { MktEnvironmentService } from 'src/app/core/services';
import { ActivatedRoute } from '@angular/router';

@Injectable()

/**
 * Use this service to store/retrive common logics for Citi shop
 */
export class CitiShopPropsService {

  content: any = {};
  downloadNowBtnLbl = signal<string>("Enroll Now");
  addToBrowserBtnLbl = signal<string>(null);
  eanbleDownloadButton = signal<boolean>(true);
  addToBrowserUrl = signal<string>('');
  isBrowser = signal<boolean>(false);
  browserName = signal<string>('Unknown');
  isPlatformDesktop = signal<boolean>(true);
  isSuspendDialogEnable = signal<boolean>(false);
  imagePrefix = signal<string>('');
  userIsEnrolled = signal<boolean>(false);

  constructor(
    @Inject(PLATFORM_ID) private _platformId: string,
    private mktEnvironmentService: MktEnvironmentService,
    private route: ActivatedRoute) {      
      const loginStatus = (this.route.snapshot.queryParams['wfextenrolled'] || 'false');
      this.userIsEnrolled.set(loginStatus === 'true');
      this.isBrowser.set(isPlatformBrowser(this._platformId));
      if(isPlatformBrowser(this._platformId)){
        this.browserName.set(this.isBrowser() ? getBrowserName() : 'Unknown');
        this.isPlatformDesktop.set(this.isBrowser() ? isDesktop() : true);
        this.eanbleDownloadButton.set(
          (this.isPlatformDesktop() || this.browserName()?.toLowerCase() === 'safari') ? true : false);
      }
    }

  extractContent(cont: any = {}){
    if(cont) this.content = cont;
    if (this.content?.TEXT) {
      this.downloadNowBtnLbl.set(this.content?.TEXT?.addToBrowserBtnLbl?.['default'] || `Enroll Now`);
      this.addToBrowserBtnLbl.set(this.content?.TEXT?.addToBrowserBtnLbl?.[this.browserName()?.toLowerCase()] || null);
      this.addToBrowserUrl.set(this.content?.TEXT?.addToButtonUrl);
      this.imagePrefix.set(this.mktEnvironmentService.getEnvironmentVar('cardsmkrHostName'));
    }
    if (this.content?.suspendDialogParams?.isDialogEnable) {
      this.isSuspendDialogEnable.set(true);
    }
  }
}
